import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "border-t border-dashed border-gray-200 my-3" }, null, -1)
const _hoisted_2 = { class: "flex items-center gap-1.5" }

import DsSwitch from '@/components/designSystem/Switch/index.vue'

const PERMANENCE_TOOLTIP_TEXT =
  'Auto check-out/check-in na transição de plantões sequenciais da mesma escala, quando o médico permanece sem registrar saída.'

export default /*#__PURE__*/_defineComponent({
  __name: 'PermanenceToggleField',
  props: {
    modelValue: { type: Boolean },
    dataTestid: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {






return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DsSwitch, {
        "model-value": _ctx.modelValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event))),
        "data-testid": _ctx.dataTestid,
        label: "🔗 Registro de Permanência",
        size: "small"
      }, null, 8, ["model-value", "data-testid"]),
      _createVNode(_component_v_tooltip, { text: PERMANENCE_TOOLTIP_TEXT }, {
        activator: _withCtx(({ props: tooltipProps }) => [
          _createElementVNode("span", _mergeProps(tooltipProps, { class: "inline-flex items-center justify-center w-[14px] h-[14px] rounded-full border border-gray-400 text-[9px] text-gray-500 cursor-help" }), "?", 16)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("p", { class: "text-[10px] text-gray-500 leading-snug mt-1" }, _toDisplayString(PERMANENCE_TOOLTIP_TEXT))
  ]))
}
}

})